const ADMIN_EMAILS = ['@binosight.com', '@prifloat.se'];

export default function isAdminEmail(email?: string) {
    return (
        email && ADMIN_EMAILS.some((adminEmail) => email.endsWith(adminEmail))
    );
}
